export const initialCustomer = {
    codiceFiscale: "",
    id: "",
    integrationId: "0692486",
    name: "Prenatal Retail Group",
    pIva: ""
}
